import type { IKpiRepository, KpiUpdateInput } from '../repositories/IKpiRepository.js';
import type { KpiEntity } from '../entities/KpiEntity.js';

export interface UpdateKpiInput { id: string; data: KpiUpdateInput; }
interface Deps { kpiRepository: IKpiRepository; }
export function createUpdateKpiUseCase({ kpiRepository }: Deps) {
  return async function updateKpi({ id, data }: UpdateKpiInput): Promise<KpiEntity | null> {
    return kpiRepository.update(id, data);
  };
}
